export function operacaoCotaDistribVeiculoInRequest(params = {}) {
  return {
    type: '@operacaocotadistribveiculo/VISUACOTADISTRIBVEICULO_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoCotaDistribVeiculo(orga_codigo, unid_cogigo, veic_placa) {
  return {
    type: '@operacaocotadistribveiculo/FIND_VISUACOTADISTRIBVEICULO',
    payload: { orga_codigo, unid_cogigo, veic_placa },
  };
}

export function failedRequest() {
  return {
    type: '@operacaocotadistribveiculo/FAILED_REQUEST',
  };
}

export function deleteOperacaoCotaDistribVeiculo(orga_codigo, unid_cogigo, veic_placa, params) {
  return {
    type: '@operacaocotadistribveiculo/DELETE_VISUACOTADISTRIBVEICULO',
    payload: { orga_codigo, unid_cogigo, veic_placa, params },
  };
}

export function updateOperacaoCotaDistribVeiculo(operacaocotadistribveiculo, params) {
  return {
    type: '@operacaocotadistribveiculo/UPDATE_VISUACOTADISTRIBVEICULO',
    payload: { operacaocotadistribveiculo, params },
  };
}

export function storeOperacaoCotaDistribVeiculo(operacaocotadistribveiculo, params) {
  return {
    type: '@operacaocotadistribveiculo/STORE_VISUACOTADISTRIBVEICULO',
    payload: { operacaocotadistribveiculo, params },
  };
}

export function successInRequest(
  operacaocotadistribveiculo,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaocotadistribveiculo/SUCCESS_IN_REQUEST',
    payload: { operacaocotadistribveiculo, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(operacaocotadistribveiculo) {
  return {
    type: '@operacaocotadistribveiculo/SUCCESS_REQUEST',
    payload: { operacaocotadistribveiculo },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaocotadistribveiculo/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaocotadistribveiculo/RECORD_FILTERING',
    payload: { params },
  };
}
